var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestopedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.752 25.427l6.33 4-2.42 22.87 34.06-20.77a36 36 0 1 0-70.5 13.77l32.53-19.87z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.792 63.837l-6.33-4 2.42-22.86-26.64 16.26a36 36 0 0 0 67.53-12l-36.98 22.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F64E00",
    cx: 37.962,
    cy: 17.047,
    r: 5.09
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestopedia);
export default __webpack_public_path__ + "static/media/investopedia.5709de430c73e85d6960710569a28211.svg";
export { ForwardRef as ReactComponent };